export default "__VITE_ASSET__07E8V6DE__"